import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
//Function to create a pie chart using hook
const Pie = props => {
  const ref = useRef(null);
  var radius = props.width / 2;
  const createPie = d3.pie().value(d => d.value).sort(null);
  const createArc = d3.arc().innerRadius(props.innerRadius).outerRadius(radius);
  const newarc = d3.arc().innerRadius(2 * radius / 4).outerRadius(radius);  
  //var p = Math.max(0, d3.precisionFixed(0.05) - 2),
  //    f = d3.format("." + p + "%");

  //Hook will trigger for everytime on data props changed
  useEffect(() => {
    const data = createPie(props.data);
    const group = d3.select(ref.current)
    const groupWithData = group.selectAll("g.arc").data(data);      

    groupWithData.exit().remove();

    const groupWithUpdate = groupWithData.enter().append("g").attr("class", "arc")
    const path = groupWithUpdate.append("path").merge(groupWithData.select("path.arc"))      
    path
      .attr("class", "arc")        
      .attr("d", createArc)
      .attr("fill", (d, i) => d.data.color)
    const text = groupWithUpdate.append("text").merge(groupWithData.select("text"))
    text        
      .attr("text-anchor", "middle")
      .attr("transform", d => `translate(${newarc.centroid(d)})`)              
      .style("fill", "white")
      .style("font-size", '13px')
      .style("font-weight", 'bold')
      .text(d => d.value+'%'+' '+ d.data.title)
  }, [props.data]);

  //Render PIE chart using SVG
  return (
    <svg 
      width={props.width} 
      height={props.height}
      viewBox={`0 0 ${Math.min(props.width,props.height)} ${Math.min(props.width,props.height)}`}
    >
      <g
        ref={ref}
        width={props.width} 
        height={props.height}
        transform={`translate(${props.width / 2},${props.height / 2})`}        
      />
    </svg>
  );
};

export default Pie;
